import { Narrow } from "component/basics";
import { ChannelAssignmentDropDown } from "open-modules/zdf/component/channels/channel-dropdown";
import { DemoSection } from "system/demo";
import { Datastore } from "util/datastore";
import { channelDemoData1, channelDemoData2, channelDemoData3, channelDemoData5, channelDemoData7 } from "../../../open-modules/zdf/component/channels/__demos__/channel-demo.data";

export function ChannelAssignmentDropDownDemo() {

    const roles = ["Moderator"];
    
    return <Narrow>
        <DemoSection text={"No channel assigned, 2 memberships & default channel available"}>
            <Datastore testState={{ modulePublic: channelDemoData1.modulePublic, serverCall: channelDemoData1.serverCall, sessionData: { personaKey: "a" }, roles }}>
                <ChannelAssignmentDropDown/>
            </Datastore>
        </DemoSection>
        <DemoSection text={"Channel assigned, 2 memberships & default channel available"}>
            <Datastore testState={{ modulePublic: channelDemoData7.modulePublic, serverCall: channelDemoData7.serverCall, sessionData: { personaKey: "a" }, roles }}>
                <ChannelAssignmentDropDown structureKey={"question"} instanceKey={"test"}/>
            </Datastore>
        </DemoSection>
        <DemoSection text={"No channel assigned, default channel available"}>
            <Datastore testState={{ modulePublic: channelDemoData2.modulePublic, serverCall: channelDemoData2.serverCall, sessionData: { personaKey: "b" }, roles }}>
                <ChannelAssignmentDropDown />
            </Datastore>
        </DemoSection>
        <DemoSection text={"No channel assigned, no memberships, no default channel"}>
            <Datastore testState={{ modulePublic: channelDemoData5.modulePublic, serverCall: channelDemoData5.serverCall, sessionData: { personaKey: "c" }, roles }}>
                <ChannelAssignmentDropDown />
            </Datastore>
        </DemoSection>
        <DemoSection text={"Channel assigned but not a member of this channel"}>
            <Datastore testState={{ modulePublic: channelDemoData3.modulePublic, serverCall: channelDemoData3.serverCall, sessionData: { personaKey: "c" }, roles }}>
                <ChannelAssignmentDropDown structureKey={"question"} instanceKey={"test"}/>
            </Datastore>
        </DemoSection>
        <DemoSection text={"No channel assigned, no channels exist (not visible)"}>
            <Datastore testState={{ modulePublic: null, serverCall: channelDemoData2.serverCall, sessionData: { personaKey: "c" }, roles }}>
                <ChannelAssignmentDropDown />
            </Datastore>
        </DemoSection>
    </Narrow>
}